module.exports = __webpack_public_path__ + "static/media/tooltip_job.f9c3316f.svg";